import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

import useResponsive from '@/hooks/useResponsive';

import useServices from './useServices';

interface IService {
  label: string;
  link: string;
  value: boolean | number;
}

const Services = () => {
  const isDesktop = useResponsive('up', 'xl');
  const hook = useServices();
  const theme = useTheme();

  return (
    <>
      {hook.loading ? (
        <Typography variant="h4">Cargando servicios...</Typography>
      ) : (
        <>
          <Box>
            <Typography variant="h6" sx={{ marginBottom: '1rem' }}>
              Mis servicios activos
            </Typography>
            <Grid container spacing={1} sx={{ gap: '1rem' }}>
              {hook.availableServices.length === 0 ? (
                <Typography variant="h4">No tienes servicios activos.</Typography>
              ) : (
                hook.availableServices.map((service: IService) => (
                  <Link
                    href={service.link !== '' ? service?.link : undefined}
                    underline="none"
                    target="_blank"
                  >
                    <Chip
                      icon={hook.iconProducts(false, service.label)}
                      label={service.label}
                      sx={{
                        backgroundColor: theme.palette.primary.lighter,
                        padding: isDesktop ? '0.8rem 0.5rem' : '0.3rem 0.1rem',
                        color: theme.palette.primary.main,
                        fontWeight: '700',
                        fontSize: '1rem',
                        height: isDesktop ? '3.125rem' : '2rem',
                      }}
                      size="medium"
                    />
                  </Link>
                ))
              )}
            </Grid>
          </Box>
          <Divider sx={{ margin: '1rem 0' }} />
          <Box>
            <Typography variant="h6" sx={{ marginBottom: '1rem' }}>
              Servicios inactivos
            </Typography>
            {hook.unavailableServices.length === 0 ? (
              <Typography>No tienes servicios inactivos.</Typography>
            ) : (
              <Typography
                sx={{ color: theme.palette.grey[600], fontWeight: '400', marginBottom: '1rem' }}
              >
                ¿Te interesa explorar algunos de estos servicios?{' '}
                <Link
                  sx={{
                    fontStyle: 'italic',
                    fontWeight: '500',
                    color: theme.palette.grey[500],
                    textDecoration: 'underline ',
                  }}
                  underline="none"
                  target="_blank"
                  href={
                    hook.country === 'CHL'
                      ? 'https://mgei8h73g11.typeform.com/leadsCL?utm_medium=signupCL'
                      : hook.country === 'PER'
                        ? 'https://mgei8h73g11.typeform.com/leadsPE?utm_medium=webPE'
                        : 'https://mgei8h73g11.typeform.com/to/eGxnTw0y'
                  }
                >
                  Contacta a un asesor de ventas.
                </Link>
              </Typography>
            )}
            <Grid container spacing={1} sx={{ marginBottom: '1rem' }}>
              {hook.unavailableServices.map((service: IService) => (
                <Link
                  href={service.link !== '' ? service?.link : undefined}
                  underline="none"
                  target="_blank"
                >
                  <Chip
                    icon={hook.iconProducts(false, service.label)}
                    label={service.label}
                    disabled
                    sx={{
                      padding: isDesktop ? '0.8rem 0.5rem' : '0.3rem 0.1rem',
                      fontWeight: '700',
                      fontSize: '1rem',
                      height: isDesktop ? '3.125rem' : '2rem',
                    }}
                    size="medium"
                  />
                </Link>
              ))}
            </Grid>
          </Box>
        </>
      )}
    </>
  );
};

export default Services;
